import { Components, Theme } from '@mui/material/styles';

export const MuiAccordionSummary: Components<Theme>['MuiAccordionSummary'] = {
  styleOverrides: {
    root: {
      backgroundColor: 'var(--palette-background)',
    },
  },
};
